module.exports = __webpack_public_path__ + "img/bg-type-item.jpg?89638bd8c4dfb0bae56b801eb962dabc";